import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import util from "@/libs/util";
export default {
  name: "user-manager",
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        url: "",
        account: "",
        pwd: "",
        name: "",
        serviceName: "",
        welcomeMsg: "",
        role: []
      },
      dialogVisible: false,
      // 弹窗状态
      checkedRole: [],
      roleOptions: [{
        value: "BD",
        label: "BD"
      }, {
        value: "CUSTOMER_SERVICE",
        label: "客服"
      }, {
        value: "FINANCE",
        label: "财务"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleCheckedRole: function handleCheckedRole() {
      var _this2 = this;
      var arr = this.checkedRole.sort();
      this.form.role = arr.map(function (label) {
        var _this2$roleOptions$fi;
        return ((_this2$roleOptions$fi = _this2.roleOptions.find(function (option) {
          return option.label === label;
        })) === null || _this2$roleOptions$fi === void 0 ? void 0 : _this2$roleOptions$fi.value) || "";
      }).filter(function (value) {
        return value;
      });
    },
    //如果为 登录人 power 为 1 则可以操作修改所有人
    //如果登录人 power 为 2 则可以操作所有 power 为 2 的人
    operable: function operable(power) {
      var adminId = util.cookies.get("uuid") || "";
      var admin = this.tableData.find(function (item) {
        return item.id === adminId;
      });
      if (admin.power === 1) {
        return true;
      } else if (power === 2 && admin.power === 2) {
        return true;
      }
      return false;
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.tableLoading = true;
              _context2.n = 1;
              return _this3.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context2.v;
              _this3.tableData = res.data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  roleDisplay: _this3.setRoleName(item)
                });
              });
              _this3.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setRoleName: function setRoleName(item) {
      var _this4 = this;
      if (!(item !== null && item !== void 0 && item.role)) return "";
      return item.role.sort().map(function (role) {
        var _this4$roleOptions$fi;
        return ((_this4$roleOptions$fi = _this4.roleOptions.find(function (option) {
          return option.value === role;
        })) === null || _this4$roleOptions$fi === void 0 ? void 0 : _this4$roleOptions$fi.label) || "";
      }).filter(function (label) {
        return label;
      }).join("、");
    },
    updateDialog: function updateDialog(row) {
      this.form = JSON.parse(JSON.stringify(row));
      if (!this.form.role) this.$set(this.form, "role", []);
      this.checkedRole = this.form.role.length ? this.form.roleDisplay.split("、") : [];
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this5$form, _this5$form2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!((_this5$form = _this5.form) !== null && _this5$form !== void 0 && _this5$form.role.includes("CUSTOMER_SERVICE") && !((_this5$form2 = _this5.form) !== null && _this5$form2 !== void 0 && _this5$form2.serviceName))) {
                _context3.n = 1;
                break;
              }
              _this5.$message.error("请填写客服昵称");
              return _context3.a(2);
            case 1:
              if (!(!_this5.form.account || !_this5.form.url || !_this5.form.name)) {
                _context3.n = 2;
                break;
              }
              _this5.$message.error("请填写完整信息");
              return _context3.a(2);
            case 2:
              if (!_this5.form.id) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return _this5.$api.updateAdmin(_this5.form);
            case 3:
              _context3.n = 6;
              break;
            case 4:
              if (_this5.form.pwd) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2, _this5.$message.error("请填写完整信息"));
            case 5:
              _context3.n = 6;
              return _this5.$api.addAdmin(_this5.form);
            case 6:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 7:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this6.$api.deleteAdmin({
                id: row.id
              });
            case 1:
              _this6.$message.success("操作成功");
              _this6.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {});
    }
  }
};